import { render, staticRenderFns } from "./pedido_cliente.vue?vue&type=template&id=3dfa835e&"
import script from "./pedido_cliente.vue?vue&type=script&lang=js&"
export * from "./pedido_cliente.vue?vue&type=script&lang=js&"
import style0 from "./pedido_cliente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports